<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    :width="width"
    :height="height"
    viewBox="0 0 24 24">
    <title :id="iconName">{{ iconName }} icon</title>
    <g :fill="iconColor">
      <path
        d="M7.875 16.188a5.694 5.694 0 0 1 5.688-5.688c.545 0 1.092.08 1.624.238a.426.426 0 0 0 .386-.067.435.435 0 0 0 .177-.352V3.063c0-.724-.589-1.313-1.313-1.313h-.874a.438.438 0 0 0-.438.438v.875c0 .723-.589 1.312-1.313 1.312H3.939a1.314 1.314 0 0 1-1.313-1.312v-.875a.438.438 0 0 0-.438-.438h-.874C.589 1.75 0 2.34 0 3.063v16.625C0 20.41.589 21 1.313 21h7.984a.438.438 0 0 0 .226-.813 5.637 5.637 0 0 1-1.648-4m8.879 2.289a3.72 3.72 0 0 0-1.739-1.541c.448-.4.735-.976.735-1.622a2.19 2.19 0 0 0-2.188-2.188 2.19 2.19 0 0 0-2.187 2.188c0 .646.287 1.221.735 1.622a3.72 3.72 0 0 0-1.739 1.54 3.904 3.904 0 0 1-.746-2.287 3.942 3.942 0 0 1 3.938-3.938 3.942 3.942 0 0 1 3.937 3.938c0 .856-.282 1.642-.746 2.288m-3.192-7.1a4.818 4.818 0 0 0-4.812 4.812 4.8 4.8 0 0 0 1.409 3.4c.002 0 .002.004.003.005.009.008.02.014.03.025.21.205.438.395.683.56.027.019.056.034.084.05.234.153.479.286.738.395.03.013.06.022.091.033.262.105.534.19.816.248.017.004.035.004.051.007.294.057.597.09.908.09.31 0 .613-.033.908-.09.016-.003.034-.003.05-.007.283-.059.554-.143.817-.248.03-.012.061-.02.09-.034.26-.11.505-.242.738-.394.029-.017.057-.032.084-.05.245-.166.473-.355.684-.561.009-.01.02-.016.03-.025l.003-.006a4.8 4.8 0 0 0 1.408-3.398 4.818 4.818 0 0 0-4.813-4.813M3.938 3.5h7.874a.438.438 0 0 0 .438-.437v-.875c0-.724-.589-1.313-1.313-1.313H9.386A1.752 1.752 0 0 0 7.875 0c-.627 0-1.2.342-1.51.875H4.812c-.723 0-1.312.59-1.312 1.313v.875c0 .24.196.437.438.437" />
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "report",
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>

<style scoped>
svg {
  display: inline-block;
  vertical-align: baseline;
}
</style>
